// Feature flags for cb2.
//
// Reports-only mode (spec 032): cb2 is reports-focused for now, so by default we
// hide the left navigation and land everyone on the report center (/reports). The
// other pages still exist and remain reachable by direct URL — they're just not
// surfaced in nav. Disable for a build with VITE_REPORTS_ONLY_MODE=false to restore
// the full sidebar + dashboard landing.
//
// NOTE: Vite inlines import.meta.env.VITE_* at BUILD time, so flipping this flag
// requires a rebuild (consistent with the global, env-overridable design — there is
// no per-user runtime toggle). Mirrors the config idiom in auth.js / tenant.js.

// ON by default; OFF only when explicitly set to the string 'false'.
export const REPORTS_ONLY_MODE = import.meta.env.VITE_REPORTS_ONLY_MODE !== 'false'

// Single source of truth for the app's landing / "home" route. Used by the index
// route and the post-auth redirects so they all agree.
export const HOME_ROUTE = REPORTS_ONLY_MODE ? '/reports' : '/dashboard'

// AI report summary (spec 035): a "✨ AI Summary" button on report views sends the
// report's columns / totals / a row sample to Cloudflare Workers AI for a plain-
// language summary. ON by default; disable a build with VITE_AI_REPORT_SUMMARY=false.
export const AI_REPORT_SUMMARY = import.meta.env.VITE_AI_REPORT_SUMMARY !== 'false'

// Smart search (spec 036): the Report Center search shows Workers-AI-ranked report
// suggestions for the typed query (grounded in the real catalog). ON by default;
// disable a build with VITE_SMART_SEARCH=false.
export const SMART_SEARCH = import.meta.env.VITE_SMART_SEARCH !== 'false'

// Shared saved views (CC-49595): the report Views menu can share a saved view
// with a group or the whole firm (server-stored in cb-api's D1; "Only me" views
// stay on-device). OFF by default; turned ON for QA via deploy-qa.yml
// (VITE_SHARED_VIEWS=true) for the group/admin-gate verification pass. PROD stays
// off until those gates are verified against real CB group data, then enable it
// in deploy-prod.yml — matches the DASHBOARDS_TAB QA-first pattern.
export const SHARED_VIEWS = import.meta.env.VITE_SHARED_VIEWS === 'true'

// Dashboards tab (spec 038): a "Dashboards | Reports" toggle in the Report Center
// that surfaces the legacy HomePage dashboards (bridged via cb-api's dashboards
// domain). Dashboards is first + the default view, so it becomes the effective
// landing page in reports-only mode. OFF by default — enable a build with
// VITE_DASHBOARDS_TAB=true — until the widget set (KPIs / tasks) is fully wired.
export const DASHBOARDS_TAB = import.meta.env.VITE_DASHBOARDS_TAB === 'true'

// Per-firm column renaming (spec 061). A firm admin renames a report's columns
// to the firm's own vocabulary; everyone at the firm then sees those words.
// OFF by default, mirroring SHARED_VIEWS — the write path is admin-gated
// server-side and changes what every user of a financial report reads, so it
// goes on per-environment after the gate is verified against real CB data.
// NOTE: while off, cb2 must display CB's labels and offer no editor at all —
// see useColumnAliases, which returns the refusing shape rather than just an
// empty alias map, so the affordance cannot appear with nothing behind it.
export const COLUMN_ALIASES = import.meta.env.VITE_COLUMN_ALIASES === 'true'
